import { API_LIMIT_DATA } from '../utils/constants';
import * as actions from './constants';

const initialState = {
  orgFeeds: null,
  personalFeeds: null,
  orgFeedOffset: 1,
  personalFeedOffset: 1,
  orgFeedHasMore: false,
  personalFeedHasMore: false
};

// eslint-disable-next-line default-param-last
export default function feedsReducer(state = initialState, action) {
  switch (action.type) {
    // Setting new feeds every time when api calls
    case actions.SET_ORG_FEEDS: {
      let newFeeds;
      if (state.orgFeeds) {
        // Check if feed is not duplicated.
        const uniqueFeed = [];
        action.payload.feeds.forEach((feed) => {
          const findIndex = state.orgFeeds.findIndex((f) => f.id === feed.id);
          if (findIndex === -1) {
            uniqueFeed.push(feed);
          }
        });
        newFeeds = [...state.orgFeeds, ...uniqueFeed];
      } else {
        newFeeds = action.payload.feeds;
      }
      return {
        ...state,
        orgFeeds: newFeeds,
        orgFeedOffset: action.payload.offset,
        orgFeedHasMore: action.payload.feeds.length === API_LIMIT_DATA
      };
    }
    case actions.SET_PERSONAL_FEEDS: {
      let newFeeds;
      if (state.personalFeeds) {
        // Check if feed is not duplicated.
        const uniqueFeed = [];
        action.payload.feeds.forEach((feed) => {
          const findIndex = state.personalFeeds.findIndex((f) => f.id === feed.id);
          if (findIndex === -1) {
            uniqueFeed.push(feed);
          }
        });
        newFeeds = [...state.personalFeeds, ...uniqueFeed];
      } else {
        newFeeds = action.payload.feeds;
      }
      return {
        ...state,
        personalFeeds: newFeeds,
        personalFeedOffset: action.payload.offset,
        personalFeedHasMore: action.payload.feeds.length === API_LIMIT_DATA
      };
    }

    // Add new feed to org and personal
    case actions.ADD_FEED: {
      let newOrgFeed = state.orgFeeds;
      if (action.payload.addToOrg) {
        newOrgFeed = state.orgFeeds
          ? [action.payload.feedObj, ...state.orgFeeds]
          : [action.payload.feedObj];
      }
      return {
        ...state,
        orgFeeds: newOrgFeed,
        personalFeeds: state.personalFeeds
          ? [action.payload.feedObj, ...state.personalFeeds]
          : [action.payload.feedObj]
      };
    }

    // Update feed in both states
    case actions.UPDATE_FEED: {
      const updatedOrgFeed = state.orgFeeds;
      const { feedObj } = action.payload;
      if (action.payload.isUpdateOrg && state.orgFeeds) {
        const orgFeedIndex = updatedOrgFeed.findIndex(
          (cd) => (cd?.id ?? cd?._id) === (feedObj?.id ?? feedObj?._id)
        );
        updatedOrgFeed[orgFeedIndex] = feedObj;
      }
      const prsnlFeedIndex = state?.personalFeeds?.findIndex(
        (cd) => (cd?.id ?? cd?._id) === (feedObj?.id ?? feedObj?._id)
      );
      state.personalFeeds[prsnlFeedIndex] = feedObj;
      return {
        ...state,
        orgFeeds: [...updatedOrgFeed],
        personalFeeds: [...state.personalFeeds]
      };
    }

    // Delete feed from org and personal
    case actions.DELETE_ORG_FEED: {
      const orgFeedObj = action.payload.feedObj;
      if (state.orgFeeds) {
        const orgFeedIndex = state.orgFeeds.findIndex((cd) => cd.id === orgFeedObj.id);
        let newOrgFeeds = [];
        if (orgFeedIndex > -1) {
          newOrgFeeds = [
            ...state.orgFeeds.slice(0, orgFeedIndex),
            ...state.orgFeeds.slice(orgFeedIndex + 1)
          ];
        }
        return {
          ...state,
          orgFeeds: newOrgFeeds
        };
      }
      return { ...state };
    }
    case actions.DELETE_PERSONAL_FEED: {
      const prsnlFeedObj = action.payload.feedObj;
      if (state.personalFeeds) {
        const prsnlFeedIndex = state.personalFeeds.findIndex((cd) => cd.id === prsnlFeedObj.id);
        let newPersonalFeeds = [];
        if (prsnlFeedIndex > -1) {
          newPersonalFeeds = [
            ...state.personalFeeds.slice(0, prsnlFeedIndex),
            ...state.personalFeeds.slice(prsnlFeedIndex + 1)
          ];
        }
        return {
          ...state,
          personalFeeds: newPersonalFeeds
        };
      }
      return state;
    }

    // Reset all state
    case actions.RESET_STATE:
      return {
        orgFeeds: null,
        personalFeeds: null,
        orgFeedOffset: 0,
        personalFeedOffset: 0,
        orgFeedHasMore: false,
        personalFeedHasMore: false
      };
    default:
      return state;
  }
}
